import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-service-mon',
    templateUrl: './service-mon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./service-mon.component.scss'],
})
export class ServiceMonComponent {}
